/** Сокращает имя файла */
export function trimFileName(fileName, maxLength) {
    if (maxLength === void 0) { maxLength = 30; }
    return fileName.length > maxLength
        ? fileName.slice(0, maxLength - 3) + '...'
        : fileName;
}
/** Кадрирует изображение */
export function getCroppedImg(image, crop, fileName) {
    var canvas = document.createElement('canvas');
    var scaleX = image.naturalWidth / image.width;
    var scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    var ctx = canvas.getContext('2d');
    var croppedWidth = crop.width * scaleX;
    var croppedHeight = crop.height * scaleY;
    ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, croppedWidth, croppedHeight, 0, 0, croppedWidth, croppedHeight);
    return new Promise(function (resolve, reject) {
        canvas.toBlob(function (blob) {
            if (blob) {
                var file = new File([blob], fileName, {
                    type: 'image/png',
                    lastModified: Date.now()
                });
                file.width = croppedWidth;
                file.height = croppedHeight;
                file.aspect = croppedWidth / croppedHeight;
                resolve(file);
            }
            else {
                reject();
            }
        }, 'image/png', 1);
    });
}
/** Добавляет ширину, высоту и аспект к информации о файле */
export function getImageFrom(file) {
    return new Promise(function (resolve, reject) {
        var url = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function () {
            var width = img.naturalWidth, height = img.naturalHeight;
            var aspect = width / height;
            URL.revokeObjectURL(img.src);
            var image = file;
            image.width = width;
            image.height = height;
            image.aspect = aspect;
            resolve(image);
        };
        img.onerror = reject;
        img.src = url;
    });
}
